import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { Observable } from 'rxjs';
import { SvgIconModule } from '../../../../svg-icon/svg-icon.module';
import { ComponentSidebarService } from '../../../component-sidebar.service';

@Component({
  selector: 'twaice-fe-alerts-component-rule-actions',
  imports: [CommonModule, SvgIconModule, NzButtonModule, NzToolTipModule],
  templateUrl: './component-rule-actions.component.html',
})
export class ComponentRuleActionsComponent implements OnInit {
  @Input() ruleBk: string;

  hasNavigteToDataExplorerAction$: Observable<boolean>;

  constructor(private componentSidebarService: ComponentSidebarService) {}

  ngOnInit() {
    this.hasNavigteToDataExplorerAction$ = this.componentSidebarService.hasNavigteToDataExplorerAction$(this.ruleBk);
  }

  navigateToDataExplorer(ruleBk: string): void {
    this.componentSidebarService.navigateToDataExplorer(ruleBk);
  }
}
